const PASSWORD_RULES = [
  {
    test: (password: string) => password.length >= 8,
    live: "At least 8 characters",
    submit: "Password must be at least 8 characters long",
  },
  {
    test: (password: string) => /[A-Z]/.test(password),
    live: "Include an uppercase letter",
    submit: "Include at least one uppercase letter",
  },
  {
    test: (password: string) => /[a-z]/.test(password),
    live: "Include a lowercase letter",
    submit: "Include at least one lowercase letter",
  },
  {
    test: (password: string) => /\d/.test(password),
    live: "Include a number",
    submit: "Include at least one number",
  },
  {
    test: (password: string) => /[!@#$%^&*(),.?":{}|<>]/.test(password),
    live: "Include a special character",
    submit: "Include at least one special character",
  },
] as const;

export const getPasswordRequirements = (password: string): string[] =>
  PASSWORD_RULES.filter((rule) => !rule.test(password)).map((rule) => rule.live);

export const validatePassword = (
  password: string
): { isValid: boolean; messages: string[] } => {
  const messages = PASSWORD_RULES.filter((rule) => !rule.test(password)).map(
    (rule) => rule.submit
  );
  return { isValid: messages.length === 0, messages };
};
